<template>
	<!-- 服务资质申请 -->
	<v-dialog v-model="dialog" persistent max-width="500" max-height="845">
		<v-card class="elevation-0" max-height="845">
			<v-card-title>
				资质申请<v-spacer></v-spacer>
				<v-btn class="mx-0" icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider />

			<v-stepper v-model="e1" class="elevation-0">
				<v-stepper-header class="elevation-0">
					<v-stepper-step @click="stepper1" :complete="e1 > 1" step="1" class="vtk-cursor-pointer"> 服务地区 </v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step @click="stepper2" :complete="e1 > 2" step="2" class="vtk-cursor-pointer"> 服务资质 </v-stepper-step>
				</v-stepper-header>
				<v-divider />

				<v-stepper-items>
					<v-stepper-content step="1" class="px-0 pb-0 pt-3">
						<v-text-field v-model="condition" @click:clear="desserts = dessertsAll" @change="search" @click:append="search" placeholder="请输入地区名称检索" class="mx-3 mb-3" outlined dense hide-details clearable append-icon="mdi-magnify"></v-text-field>
						<v-divider />

						<v-card min-height="500" class="elevation-0 rounded-0">
							<v-data-table @click:row="apply" :headers="headers" :items="desserts" disable-pagination loading-text="数据加载中..." class="elevation-0 vtk-cursor-pointer" hide-default-header hide-default-footer>
								<template v-slot:[`item.areaName`]="{ item }">
									<v-list-item class="pr-2">
										<v-list-item-content>
											<v-list-item-title class="body-2">
												{{ item.areaName }}
												<v-chip v-if="item.state == '0'" class="red lighten-5 red--text px-2" style="height: 18px" x-small label> 未上线 </v-chip>
											</v-list-item-title>
											<v-list-item-subtitle class="caption mt-2">
												<v-icon size="16" class="mr-1" color="green">mdi-phone-dial</v-icon>{{ item.servTele }} <v-icon size="16" class="ml-3 mr-1" color="blue">mdi-google-maps</v-icon>{{ item.servAddr }}
											</v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<v-btn icon>
												<v-icon color="blue">mdi-chevron-right</v-icon>
											</v-btn>
										</v-list-item-action>
									</v-list-item>
								</template>
							</v-data-table>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="2" class="pa-0">
						<v-card class="elevation-0">
							<v-card-text class="pb-1">
								<v-banner class="rounded" icon-color="blue" tile single-line rounded outlined>
									<p class="pl-1 mb-1 body-1 font-weight-bold">{{ roleCreate.areaName }}</p>
									<v-icon color="blue" style="vertical-align: sub">mdi-download</v-icon>
									请下载“<a href="https://res.hzcl.org.cn/oss/hzcl/disable-wit-acis/%E7%A4%BE%E4%BC%9A%E5%8C%96%E5%8A%A9%E6%AE%8B%E6%9C%8D%E5%8A%A1%E8%B5%84%E8%B4%A8%E7%94%B3%E8%AF%B7%E8%A1%A8.docx">社会助残服务资质申请表.docx</a>”后填写签章扫描后上传
								</v-banner>
								<v-form ref="roleCreate" v-model="roleCreateValid" :model="roleCreate" class="mt-5">
									<v-file-input
										v-if="!fileShow"
										v-model="file"
										:rules="[(v) => !!v || '资质材料不能为空!']"
										accept=".jpeg,.jpg,.png,.gif,.pdf"
										label="请上传社会助残服务资质申请表"
										placeholder="请上传社会助残服务资质申请表"
										append-icon="mdi-paperclip"
										dense
										outlined>
										<template v-if="roleCreate.file && !fileShow" v-slot:append-outer>
											<v-btn @click="fileShow = !fileShow" class="mt-n2" color="blue" icon elevation="0"><v-icon>mdi-close-circle</v-icon></v-btn>
										</template>
									</v-file-input>
									<v-alert v-else text class="py-1" border="left" color="blue">
										<a :href="roleCreate.file" target="_blank" style="vertical-align: -webkit-baseline-middle">社会助残服务资质申请表.docx</a>
										<v-btn @click="fileShow = !fileShow" class="float-right" color="blue" icon> <v-icon>mdi-close-circle</v-icon> </v-btn>
									</v-alert>
									<v-text-field label="业务联系人名" placeholder="业务联系人名" v-model="roleCreate.linkName" :rules="[(v) => !!v || '业务联系人名不能为空!']" dense outlined></v-text-field>
									<v-text-field label="业务联系电话" placeholder="业务联系电话" v-model="roleCreate.linkTele" :rules="rules.mobile" type="Number" dense outlined></v-text-field>
									<v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="dates" transition="scale-transition" nudge-top="24" offset-y min-width="auto">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field v-model="roleCreate.time" readonly v-bind="attrs" v-on="on" dense outlined label="时间限制" :rules="[(v) => !!v || '请选择时间区间!']" clearable></v-text-field>
										</template>
										<v-date-picker v-model="dates" :min="new Date() | date('yyyy-MM-dd')" range no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="menu = false">返回</v-btn>
											<v-btn text color="primary" @click="timeSave">确定</v-btn>
										</v-date-picker>
									</v-menu>
									<v-textarea label="申请说明" placeholder="申请说明" dense outlined v-model="roleCreate.note" :rules="[(v) => !!v || '申请说明不能为空!']" auto-grow></v-textarea>
								</v-form>
								<p>
									注意：<br />
									1. 单位服务资质由企业管理员自主申请，由对应残联审核通过；<br />
									2. 资质材料请根据<a href="https://res.hzcl.org.cn/oss/hzcl/disable-wit-acis/%E7%A4%BE%E4%BC%9A%E5%8C%96%E5%8A%A9%E6%AE%8B%E6%9C%8D%E5%8A%A1%E8%B5%84%E8%B4%A8%E7%94%B3%E8%AF%B7%E8%A1%A8.docx">社会助残服务资质申请表</a
									>填写并签章扫描后上传；<br />
									3. 单文件可直接上传，多文件请合成PDF后上传，总大小在2MB以内；<br />
									4. 服务资质审核通过后，将可以使用对应业务应用系统；<br />
									5. 以上信息请进行严格保密！！！
								</p>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions class="mx-auto">
								<v-spacer />
								<v-btn @click="close" text> 取消 </v-btn>
								<v-btn @click="submit" text color="primary"> 确定 </v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-card>
	</v-dialog>
</template>

<script>
import Request from "@/commons/request";
import Storage from "@/commons/storage";
import Message from "@/components/message";
import Validation from "@/commons/validation";
export default {
	name: "DashUrole",
	data() {
		return {
			//可申请资质地区
			e1: 1,
			dialog: false,
			desserts: [],
			dessertsAll: [],
			headers: [{ text: "资质地区", value: "areaName", sortable: false }],
			condition: "", //查询地区
			// 新增资质
			roleCreate: {},
			roleCreateValid: true,
			rules: {
				mobile: [(val) => Validation.isMobile(val) || "请填写正确的手机号码格式"],
				idCard: [(val) => Validation.isIdCard(val) || "请填写正确的身份证号码"],
			},
			menu: false,
			dates: [],
			file: null,
			// 编辑
			fileShow: false,
			examState: 0,
		};
	},
	activated() {},
	methods: {
		// 1.2目录地区资质列表
		list(bid) {
			Request.postForm("/app/abiz/serv", { bid }).then((res) => {
				this.desserts = res.data;
				this.dessertsAll = res.data;
			});
		},
		// 1.3切换顶部步骤
		stepper1() {
			if (this.roleCreate.id) {
				Message.toast("当前不允许修改地区", { color: "error" });
			} else {
				this.e1 = 1;
			}
		},
		stepper2() {
			this.roleCreate.areaCode ? (this.e1 = 2) : Message.toast("请先选择地区", { color: "error" });
		},

		// 1.4选择地址
		apply(item) {
			if (item.state == "0") {
				Message.toast("该资质在当前地区未上线！", { color: "error" });
			} else {
				this.e1 = 2;
				this.roleCreate.areaName = item.areaName;
				this.roleCreate.areaCode = item.areaCode;
			}
		},
		search() {
			this.desserts = this.condition ? this.dessertsAll.filter((item) => item.areaName.indexOf(this.condition) >= 0) : this.dessertsAll;
		},
		// 2.1新增-申请资质选择日期
		timeSave() {
			if (this.dates.length > 1) {
				this.dates = this.dates.sort();
				this.roleCreate.time = this.dates.join(" ~ ");
				this.roleCreate.btime = this.dates[0];
				this.roleCreate.etime = this.dates[1];
				this.$refs.menu.save(this.dates);
			} else {
				this.roleCreate.time = "";
				this.$refs.menu.save(this.dates);
			}
		},
		// 新增申请资质(关闭)
		add() {
			this.list(this.$route.query.pid);
			this.close();
		},
		// 关闭/打开
		close() {
			this.dates = [];
			this.$refs.roleCreate?.reset();
			this.dialog = !this.dialog;
			this.e1 = 1;
			this.examState = 0;
		},
		// 续签/编辑
		edit(item, state) {
			this.examState = state;
			this.e1 = 2;
			this.dialog = !this.dialog;
			this.roleCreate.areaName = item.areaName;
			this.roleCreate.areaCode = item.areaCode;
			if (state == 2) {
				// 编辑
				this.roleCreate = Object.assign({}, item);
				this.roleCreate.time = `${this.$options.filters["date"](item.btime, "yyyy-MM-dd")}~${this.$options.filters["date"](item.etime, "yyyy-MM-dd")}`;
				this.dates = [item.btime, item.etime];
				this.fileShow = true;
			}
			console.log(item, JSON.parse(this.roleCreate.stateJson));
		},
		// 提交资质申请
		submit() {
			let arr = [];
			if (this.$refs.roleCreate.validate()) {
				this.roleCreate.id && (arr = JSON.parse(this.roleCreate.stateJson));
				const formData = new FormData();
				this.roleCreate.bid = this.$route.query.pid;
				this.roleCreate.did = Storage.get("_wit_acis_users").did;
				this.roleCreate.bizName = this.roleCreate.projName;
				this.roleCreate.state = "0";
				arr.push({
					name: this.$options.filters["dict"](this.examState, "0:申请/1:申请/2:修改申请"),
					state: "0",
					stateNote: this.roleCreate.note,
					operator: Storage.get("_wit_acis_users").citizenName,
					operateTime: new Date(),
				});
				this.roleCreate.stateJson = JSON.stringify(arr);
				this.roleCreate.operator = Storage.get("_wit_acis_users").citizenName;
				//这里包装 可以直接转换成对象
				formData.append("ureg", new Blob([JSON.stringify(this.roleCreate)], { type: "application/json" }));
				console.log(this.file);
				if (this.file) {
					formData.append("file", this.file);
					if (this.file.size / 1024 / 1024 > 2) {
						Message.toast("上传文件大小不能超过2MB!", { color: "error" });
						return false;
					}
					// .jpeg,.jpg,.png,.gif,.pdf
					if (this.file.type != "image/jpeg" && this.file.type != "image/png" && this.file.type != "image/jpg" && this.file.type != "image/gif" && this.file.type != "application/pdf") {
						Message.toast("请上传图片或PDF!", { color: "error" });
						return false;
					}
				}
				formData.append("ureg", this.roleCreate);
				Request.imp("/udsx/dept-ureg/save", formData).then((res) => {
					if (res.meta.success) {
						Message.toast(res.meta.message, { color: "success" });
						this.close();
						this.$route.path == "/dept-ureg" && history.go();
					} else {
						Message.toast(res.meta.message, { color: "error" });
					}
				});
			}
		},
		// 返回
		retreat() {
			this.$router.push("/dept-page");
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep {
	td.text-start:nth-child(1) {
		padding: 0 !important;
		max-width: 300px;
		width: 300px;
	}
	.v-input__prepend-outer {
		display: none;
	}
	.v-banner__wrapper {
		padding-left: 8px;
	}
	.v-stepper__header {
		height: 56px;
	}
	.v-stepper__step {
		padding-top: 0;
		padding-bottom: 0;
	}
}
</style>
